import { spUrl } from "utils";
import { API_ACCOUNTS } from "globals/constants";
import { buildSearchParams, put, request, save } from "utils/proxy";


export const accounts = {
	/**
	 * @param {{ id: string }} params
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	get: (params, options) => request(spUrl(`${API_ACCOUNTS}/${params.id}`), options),

	/**
	 * @param {{id: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	update: (params, body, options) => put(spUrl(`${API_ACCOUNTS}/${params.id}/status`), body, options),

	create: (body, options) => save(spUrl(API_ACCOUNTS), body, options),

	/**
	 * @param {{ number: string }} params
	 * @param {{}?} options
	 */
	find: (params, options) => {
		const searchParams = buildSearchParams({
			search: `accountNumber:${params.number}`,
		});

		return request(spUrl(`${API_ACCOUNTS}${searchParams}`), options);
	},
};
